// @flow
import React from 'react';
import { css, cx } from 'emotion';

type Props = any;

export default function DropdownIndicator(props: Props) {
  const style = css(props.getStyles('dropdownIndicator', props));
  return (
    <span
      className={cx(
        'Select-arrow-zone',
        css({
          cursor: 'pointer',
          display: 'table-cell',
          position: 'relative',
          textAlign: 'center',
          verticalAlign: 'middle',
          width: 25,
          paddingRight: 5
        }),
        style
      )}
    >
      <span
        className={cx(
          'Select-arrow',
          css({
            borderColor: '#000 transparent transparent',
            borderStyle: 'solid',
            borderWidth: '5px 5px 2.5px',
            display: 'inline-block',
            height: 0,
            width: 0
          })
        )}
      />
    </span>
  );
}
